  <mat-card>
      <mat-card-header>
          <mat-card-title>Dettaglio sede</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">

        <form [formGroup]="registerForm" (ngSubmit)="save()">

          <mat-form-field class="example-full-width">
            <mat-label class="text-sm">Nome</mat-label>
            <input matInput placeholder="Nome" formControlName="Nome" name="Nome" required>
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label class="text-sm">Indirizzo</mat-label>
            <input matInput placeholder="Indirizzo" formControlName="Indirizzo" name="Indirizzo">         
          </mat-form-field>

      
           <mat-form-field class="example-full-width">
                <mat-label class="text-sm">CAP - {{ nomeComune }}</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autocap"
                  (keyup)="onFiltroCapKeyup($event)"
                  formControlName="Cap" 
                />
               
          
                <mat-autocomplete #autocap="matAutocomplete" (optionSelected)="onCapSelected($event)">
                  <mat-option
                    *ngFor="let comune of comunifiltrati | async"
                    [value]="comune.Cap">
                    <span>{{ comune.Cap+' - '+comune.Nome }}</span>
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>

          <mat-label class="text-sm">Il numero di dipendenti non è editabile perchè calcolato automaticamente.</mat-label>    
          

          <mat-form-field class="example-full-width">
            <mat-label class="text-sm">Numero dipendenti</mat-label>
            <input [readonly]="true" matInput placeholder="Numero dipendenti" formControlName="Numerodipendenti" name="Numerodipendenti">
          </mat-form-field>

          <mat-form-field class="example-full-width" *ngIf="false">
            <mat-label class="text-sm">Codice</mat-label>
            <input matInput placeholder="Codice" formControlName="Codice" name="Codice">
          </mat-form-field>

          <mat-form-field class="example-full-width" *ngIf="false">
            <mat-label class="text-sm">Codice Azienda</mat-label>
            <input matInput placeholder="Codiceazienda" formControlName="Codiceazienda" name="Codiceazienda">
          </mat-form-field>

        </form>
      </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button color="primary" (click)="cancel()">Indietro</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
